import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRollbar } from "@rollbar/react";
import { useEffect, useState } from "react";
import Interstitial from "~/client/components/Interstitial";
import { NotFoundError } from "~/client/errors";
import useAuthenticateMe from "~/client/hooks/api/useAuthenticateMe";
import useCreateMe from "~/client/hooks/api/useCreateMe";
import useInitializeDatabase from "~/client/hooks/useInitializeDatabase";
import { useUserId } from "~/client/storage";
import { Content, LoadingIndicator } from "./styled";
const InitializationRequired = ({ children }) => {
    const rollbar = useRollbar();
    const [userId, setUserId] = useUserId();
    const [loadingMessage, setLoadingMessage] = useState("Connecting to the database…");
    const { data: isDatabaseInitialized, isSuccess: isSuccessInitializeDatabase, mutate: initializeDatabase, } = useInitializeDatabase();
    const { mutate: authenticateMe } = useAuthenticateMe();
    const { isError: isErrorCreateMe, mutate: createMe } = useCreateMe();
    useEffect(() => {
        initializeDatabase();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (isDatabaseInitialized && !userId) {
            setLoadingMessage("Loading your user data…");
            authenticateMe(undefined, {
                onError: (error) => {
                    if (!(error instanceof NotFoundError)) {
                        rollbar.error("Impossible condition met: Authenticate endpoint returned unexpected error type.", { error });
                    }
                    setLoadingMessage("Initializing your user data…");
                    createMe(undefined, {
                        onSuccess: () => {
                            authenticateMe(undefined, {
                                onSuccess: (loadedUserId) => {
                                    setUserId(loadedUserId);
                                },
                            });
                        },
                    });
                },
                onSuccess: (loadedUserId) => {
                    setUserId(loadedUserId);
                },
            });
        }
    }, [
        authenticateMe,
        createMe,
        isDatabaseInitialized,
        rollbar,
        setUserId,
        userId,
    ]);
    const isLoading = !isSuccessInitializeDatabase || userId === null;
    const isError = isErrorCreateMe;
    if (isLoading) {
        return (_jsx(Interstitial, { contentTestAttribute: "initialization-modal", children: _jsxs(Content, { children: [_jsx(LoadingIndicator, {}), loadingMessage] }) }));
    }
    if (isError) {
        return (_jsx(Interstitial, { children: _jsx(Content, { children: "There was an error loading your data." }) }));
    }
    return children;
};
export default InitializationRequired;
